import React from 'react';
import nprogress from 'nprogress';
import PropTypes from 'prop-types';

import './nprogress.css';

class NProgressBar extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.loading) {
      nprogress.start();
    } else {
      nprogress.done();
    }
  }

  render() {
    return <div />;
  }
}

NProgressBar.propTypes = {
  loading: PropTypes.bool,
};

export default NProgressBar;



// WEBPACK FOOTER //
// ./app/components/NProgress/index.js